import React, { useState, useRef, useEffect } from "react";
// import { initializeApp } from 'firebase/app';
// import { getFirestore, collection, getDocs } from 'firebase/firestore';
// import { db} from "../firebaseConfig";
import 'firebase/firestore';
import { getFirestore, doc, setDoc } from "firebase/firestore";
import { auth, db } from '../firebaseConfig';

const useFirestore = (collectionName) => {
  const [docs, setDocs] = useState([]);

  useEffect(() => {
   
    const unsubscribe = db.collection(collectionName).onSnapshot((snapshot) => {
      const documents = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setDocs(documents);
    });

    return () => unsubscribe();
  }, [collectionName]);

  return docs;
};

const EventList = () => {
  const events = useFirestore("events");

  return (  
    <div className="upcom mt-6">
      <h1 className="text-center display-2 page-title">Upcoming Events</h1>
      <ul>
        {events.map((event) => (
          <li key={event.id}>
            <h3>{event.name}</h3>
            <p>{event.description}</p>
            <p></p>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default EventList;
